<template>
  <div>
    <div class="web-box top-page">
      <a-row>
        <a-col :xs="24" :sm="12" class="top-left">
          <p>知乎信息流</p>
          <p>用户信赖的高质量内容问答社区</p>
          <div class="color-button" @click="goCallUs">
            联系我们
            <span class="button-icon">&#xe63a;</span>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img class="jixiangwu" src="http://www.vedamobi.com/assets/website/images/zhihu/刘看山.png" />
        </a-col>
      </a-row>
    </div>
    <p class="home-title product-title">产品介绍</p>
    <div class="web-box product-wrap">
      <a-row>
        <a-col :xs="24" :sm="12">
          <img class="web-show" src="http://www.vedamobi.com/assets/website/images/zhihu/北极熊.png" />
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="product-right">
            <div class="hexagon-wrap">
              <div class="hexagon-bg"></div>
              <div class="hexagon">
                <h3>问答型社区</h3>
                <p>
                  日均搜索了 6000 万
                  <br />日均内容分享量 23 万
                  <br />日均全网阅读量 2 亿
                  <br />...
                </p>
              </div>
            </div>

            <div style="display:flex;margin-top:140px;">
              <div class="hexagon-wrap">
                <div class="hexagon-bg"></div>
                <div class="hexagon">
                  <h3>多维定向</h3>
                  <p>
                    九大基础定向维度
                    <br />19个一级分类，116个二级分类
                    <br />独特的关键词、人群拓展定向
                    <br />...
                  </p>
                </div>
              </div>

              <div class="hexagon-wrap">
                <div class="hexagon-bg"></div>
                <div class="hexagon">
                  <h3>营销工具</h3>
                  <p>
                    知乎画报
                    <br />创意灵感库
                    <br />知乎机构号营销组件
                    <br />...
                  </p>
                </div>
              </div>
            </div>
          </div>
          <swiper class="mobile-swiper" :options="swiperOption" ref="mySwiper">
            <swiper-slide>
              <div class="mobile-hexagon">
                <h3>问答型社区</h3>
                <p>
                  日均搜索了 6000 万
                  <br />日均内容分享量 23 万
                  <br />日均全网阅读量 2 亿
                  <br />...
                </p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="mobile-hexagon">
                <h3>多维定向</h3>
                <p>
                  九大基础定向维度
                  <br />19个一级分类，116个二级分类
                  <br />独特的关键词、人群拓展定向
                  <br />...
                </p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="mobile-hexagon">
                <h3>营销工具</h3>
                <p>
                  知乎画报
                  <br />创意灵感库
                  <br />知乎机构号营销组件
                  <br />...
                </p>
              </div>
            </swiper-slide>
          </swiper>
        </a-col>
      </a-row>
    </div>
    <p class="home-title product-title">媒体详情</p>
    <div class="media-wrap">
      <p class="explain">
        &emsp;&emsp;知乎是一个高质量的网络问答社区，其连接各行各业的用户。用户分享着彼此的知识、经验和见解，为中文互联网源源不断地提供多种多样的信息。准确地讲，知乎更像一个论坛：用户围绕着某一感兴趣的话题进行相关的讨论，同时可以关注兴趣一致的人。对于概念性的解释，网络百科几乎涵盖了你所有的疑问；但是对于发散思维的整合，却是知乎的一大特色。
        <br />&emsp;&emsp;有问题,上知乎。这已经是知乎最显著的特点，比起其他问答类型媒体，知乎的答案更值得用户信赖。当用户在知乎上搜索问题，近乎可以作为用户 “ 产生购买环节的最后一环 ”。
      </p>
      <div class="media-content web-show">
        <a-row>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe704;</p>
            <p>
              45%+
              <br />一线城市用户占比
            </p>
          </a-col>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe689;</p>
            <p>
              2800万
              <br />站内问题
            </p>
          </a-col>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe60e;</p>
            <p>
              1.3亿
              <br />站内回答数
            </p>
          </a-col>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe632;</p>
            <p>
              60+分钟
              <br />人均访问时长
            </p>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import ScrollReveal from "scrollreveal";
export default {
  data() {
    return {
      scrollReveal: ScrollReveal(),
      swiperOption: {}
    };
  },
  mounted() {
    this.scrollReveal.reveal(`.jixiangwu`, {
      duration: 600,
      delay: 0,
      origin: "right",
      reset: true,
      mobile: false,
      distance: "500px",
      opacity: 0.001,
      easing: "linear"
    });
    // for (const index of [1, 2, 3]) {
    //   this.scrollReveal.reveal(`.card${index}`, {
    //     // 动画的时长
    //     duration: 500,
    //     // 延迟时间
    //     delay: 200 * (index - 1),
    //     // 动画开始的位置，'bottom', 'left', 'top', 'right'
    //     origin: 'bottom',
    //     // 回滚的时候是否再次触发动画
    //     reset: true,
    //     // 在移动端是否使用动画
    //     mobile: false,
    //     // 滚动的距离，单位可以用%，rem等
    //     distance: '200px',
    //     // 其他可用的动画效果
    //     opacity: 0.001,
    //     easing: 'linear'
    //   })
    // }
  },
  methods: {
    goCallUs() {
      const btn = document.getElementById("callusForm");
      const scrollHeight = btn.offsetTop;
      window.scrollTo(0, scrollHeight);
    }
  }
};
</script>
<style lang="scss" scoped>
.top-page {
  overflow: hidden;
  padding-top: 180px;
  .top-left {
    text-align: center;
    p:nth-child(1) {
      margin-top: 160px;
      font-size: 44px;
    }
    p:nth-child(2) {
      font-size: 22px;
    }
  }
  .jixiangwu {
    width: 600px;
    height: 600px;
  }
  .button-icon {
    font-family: iconFont;
    float: right;
    padding-right: 10px;
  }
  .color-button {
    margin-top: 80px;
  }
}
.media-wrap {
  max-width: 1300px;
  width: 100%;
  padding: 0 40px;
  margin: 0 auto;
  .explain {
    font-size: 20px;
    line-height: 50px;
  }
  .media-content {
    div {
      flex: 1;
      text-align: center;
      margin-top: 40px;
      .icon {
        font-family: "iconFont";
        font-size: 100px;
        margin: 0;
      }
    }
  }
}
.product-wrap {
  padding-top: 140px;
  .product-right {
    flex-direction: column;
    align-items: center;
    display: flex;
  }
  img {
    width: 600px;
    height: 600px;
  }
  .mobile-swiper {
    display: none;
  }
  .hexagon-wrap {
    position: relative;
    margin: 0 20px;
    .hexagon-bg {
      position: relative;
      width: 370px;
      height: 195px;
      background-color: #000;
      box-shadow: 0 0 5px #000;
      &::before {
        content: "";
        position: absolute;
        top: -97.5px;
        left: 0;
        width: 0;
        height: 0;
        border-left: 185px solid transparent;
        border-right: 185px solid transparent;
        border-bottom: 97.5px solid #000;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: -97.5px;
        left: 0;
        width: 0;
        height: 0;
        border-left: 185px solid transparent;
        border-right: 185px solid transparent;
        border-top: 97.5px solid #000;
      }
    }
    .hexagon {
      position: absolute;
      width: 350px;
      height: 175px;
      background-color: #fff;
      top: 10px;
      left: 10px;
      text-align: center;
      z-index: 5;
      h3 {
        margin-top: -40px;
        font-size: 26px;
        font-weight: 600;
      }
      p {
        font-size: 18px;
        font-weight: 600;
        line-height: 46px;
      }
      &::before {
        content: "";
        position: absolute;
        top: -94px;
        left: 0;
        width: 0;
        height: 0;
        border-left: 175px solid transparent;
        border-right: 175px solid transparent;
        border-bottom: 94px solid #fff;
        z-index: -1;
      }
      &::after {
        z-index: -1;
        content: "";
        position: absolute;
        bottom: -94px;
        left: 0;
        width: 0;
        height: 0;
        border-left: 175px solid transparent;
        border-right: 175px solid transparent;
        border-top: 94px solid #fff;
      }
    }
  }
}
.product-title {
  text-align: center;
  margin-top: 200px;
}
@media (max-width: 750px) {
  .product-title {
    text-align: center;
    margin-top: 40px;
  }
  .top-page {
    overflow: hidden;
    padding-top: 80px;
    min-height: 100vh;
    .top-left {
      text-align: center;
      padding: 0 20px;
      p:nth-child(1) {
        margin-top: 60px;
        font-size: 24px;
      }
      p:nth-child(2) {
        font-size: 18px;
      }
      .color-button {
        margin-top: 30px;
      }
    }
    .jixiangwu {
      width: 100%;
      height: auto;
    }
  }
  .media-wrap {
    .explain {
      font-size: 16px;
      line-height: 30px;
    }
  }
  .product-wrap {
    padding-top: 20px;
    img {
      width: 100%;
      height: 100%;
    }
    .product-right {
      display: none;
    }
    .mobile-swiper {
      display: block;
      margin-top: 30px;
    }
  }

  .mobile-hexagon {
    background-color: #fff;
    width: 100%;
    text-align: center;
    padding: 30px 0;
    h3 {
      font-size: 24px;
    }
    p {
      font-size: 16px;
      line-height: 35px;
    }
  }
}
</style>